import { createContext, useContext } from "react"
import type { ThemeConfig } from "@/v2-ui/theme/theme.types"
import { DEFAULT_THEME_CONFIG } from "@/v2-ui/theme/theme.constants"

type ThemeContextProviderValue = {
  theme: ThemeConfig
  setTheme: (theme: ThemeConfig) => void
  toggleDarkMode: () => void
}

const DEFAULT_THEME_CTX: ThemeContextProviderValue = {
  theme: DEFAULT_THEME_CONFIG,
  setTheme: () => {},
  toggleDarkMode: () => {},
}

export const ThemeContext =
  createContext<ThemeContextProviderValue>(DEFAULT_THEME_CTX)

export function useThemeContext() {
  return useContext(ThemeContext)
}
